import React from 'react';
import GasSafetyForm from '../components/GasSafetyRecord/GasSafetyForm';

const GasSafetyRecord = () => {
    return <GasSafetyForm />;
};

export default GasSafetyRecord;
